import { Controller } from 'react-hook-form'
import EditIcon from '@mui/icons-material/Edit'
import FormFieldGroup from '../../Common/form/formFieldGroup/FormFieldGroup'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { getTooltipTitle, HIDDEN_VALUE, isEmailValid } from './_utils'
import RealEmail from './RealEmail'
import { useUserFormContext } from '../utils/userFormContext'
import { FormFieldStatusState } from '../../Common/form/formField/_props'

type EmailProps = {
    isDisabled?: boolean
}

export const Email = ({ isDisabled = false }: EmailProps) => {
    const { state, update } = useUserFormContext()
    const { control, setValue, watch } = useFormContextUser()
    const { email, selfMode } = watch()

    const handleClick = () => {
        update({
            redirectKey: 'email',
        })
    }

    const displayRealEmail = !isDisabled && !state.isEditionMode

    const actionButton = {
        label: 'Modifier',
        icon: <EditIcon />,
        action: handleClick,
    }

    return (
        <Controller
            control={control}
            name="email"
            rules={{
                validate: isDisabled ? undefined : isEmailValid,
                required: isDisabled ? undefined : 'Cette information est obligatoire et n’a pas été renseignée',
            }}
            render={({ field, fieldState: { error } }) => {
                const hasValue = (field.value?.trim().length ?? 0) > 0

                const status: FormFieldStatusState = {
                    error,
                    valid: hasValue,
                }

                return (
                    <FormFieldGroup
                        label="Courriel de contact et identifiant de connexion"
                        status={status}
                        required
                        size="0.5"
                    >
                        <UserFormField
                            status={status}
                            variant="input"
                            {...field}
                            value={state.isEditionMode && isDisabled ? HIDDEN_VALUE : field.value}
                            size="1"
                            onChange={(e) => {
                                if (field.value && !error) {
                                    setValue('notification', {
                                        email: true,
                                        sms: false,
                                    })
                                }

                                field.onChange(e)
                            }}
                            placeholder="exemple@email.fr"
                            disabled={state.isEditionMode || email?.includes('@toktokdoc.me')}
                            dataCyScope="UserField"
                            clearable={hasValue}
                            tooltipTitle={getTooltipTitle(Boolean(selfMode), state.isEditionMode, 'email')}
                            actionButton={selfMode ? actionButton : undefined}
                        />
                        {displayRealEmail && <RealEmail />}
                    </FormFieldGroup>
                )
            }}
        />
    )
}
